import { render, staticRenderFns } from "./FinancesTaxTypesForm.vue?vue&type=template&id=5bc3a95d&"
import script from "./FinancesTaxTypesForm.vue?vue&type=script&lang=js&"
export * from "./FinancesTaxTypesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports